import React from "react";
import {
  Navbar,
  Typography,
  Button,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Avatar,
} from "@material-tailwind/react";
import {
  UserCircleIcon,
  ChevronDownIcon,
  PowerIcon,
} from "@heroicons/react/24/solid";
import { newLogo } from "../../assets/Images";
import { Link, useNavigate } from "react-router-dom";
import { useReduxStore } from "../../hooks/useReduxStore.js";
import { LogoutAction } from "../../store/Actions/action.js";
import { updateItem } from "../../store/Reducers/itemReducer.js";
import { getFirstName, scrollToTop } from "../../helper/helper.js";

const profileMenuItems = [
  {
    label: "My Account",
    icon: UserCircleIcon,
    route: "/Profile",
  },
  {
    label: "Sign Out",
    icon: PowerIcon,
    route: "/",
  },
];

function ProfileMenu() {
  const { dispatch, getState } = useReduxStore();
  const { userData } = getState("AUTH");
  const { avatar } = userData || {};
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const navigate = useNavigate();
  const closeMenu = () => setIsMenuOpen(false);

  const onProfileMenuClick = (route, isLastItem) => {
    if (isLastItem) {
      dispatch(LogoutAction());
    }
    navigate(route);
    if (isLastItem) {
      scrollToTop();
    }
    closeMenu();
  };

  return (
    <Menu open={isMenuOpen} handler={setIsMenuOpen} placement="bottom-end">
      <MenuHandler>
        <Button
          variant="text"
          color="blue-gray"
          className="flex items-center gap-1.5 rounded-full py-0.5 pr-2 pl-0.5 outline-none focus:outline-none"
        >
          <Avatar
            variant="circular"
            size="sm"
            alt={userData?.name || "User"}
            className="border border-secondary p-0.5"
            src={
              avatar ||
              "https://i.pinimg.com/originals/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg"
            }
          />
          <span className="px-1 text-white text-sm font-medium font-outfit hidden sm:inline-block">
            {getFirstName(userData?.name)}
          </span>
          <ChevronDownIcon
            strokeWidth={2.5}
            className={`h-3 w-3 text-white transition-transform ${
              isMenuOpen ? "rotate-180" : ""
            }`}
          />
        </Button>
      </MenuHandler>
      <MenuList className="p-1 border border-neutral-800 bg-[#111] text-white z-[9999999]">
        {profileMenuItems.map(({ label, icon, route }, key) => {
          const isLastItem = key === profileMenuItems.length - 1;
          return (
            <MenuItem
              key={label}
              onClick={() => onProfileMenuClick(route, isLastItem)}
              className={`flex items-center gap-2 rounded hover:bg-neutral-800 focus:bg-neutral-800 active:bg-neutral-800 py-2 px-3 ${
                isLastItem ? "text-red-500 hover:text-red-400" : "text-white"
              }`}
            >
              {React.createElement(icon, {
                className: `h-4 w-4 ${isLastItem ? "text-red-500" : "text-secondary"}`,
                strokeWidth: 2,
              })}
              <Typography
                as="span"
                variant="small"
                className="font-normal font-outfit"
              >
                {label}
              </Typography>
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
}

export default function NavbarRecords() {
  const navigate = useNavigate();
  const { getState, dispatch } = useReduxStore();
  const { token } = getState("AUTH");

  const openSearchModal = () => dispatch(updateItem({ searchModal: true }));

  return (
    <Navbar
      color="transparent"
      fullWidth
      className="mx-auto max-w-screen px-4 py-3 bg-black/60 backdrop-blur-md border-b border-neutral-900 sticky top-0 z-[9999] shadow-lg"
    >
      <div className="relative mx-auto flex items-center justify-between text-white max-w-7xl">
        <Link to="/landing-new" className="flex items-center">
          <img
            className="object-contain h-10 sm:h-12 w-auto transition-transform hover:scale-105 duration-350"
            src={newLogo}
            alt="BAB Logo"
          />
        </Link>

        <div className="flex items-center gap-4">
          {/* Search Button */}
          <button
            onClick={openSearchModal}
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg border border-neutral-700/60 flex items-center justify-center text-white hover:border-[#FF8C21] hover:text-[#FF8C21] transition-all bg-black/20 outline-none focus:outline-none"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </button>

          {!token ? (
            <Button
              onClick={() => navigate("/Login", { state: { goBack: true } })}
              className="px-6 py-2 rounded-md text-xs sm:text-sm font-medium font-outfit transition-all duration-300 bg-secondary text-black hover:bg-white hover:text-black hover:shadow-lg hover:shadow-secondary/20 active:scale-95"
            >
              Log In
            </Button>
          ) : (
            <ProfileMenu />
          )}
        </div>
      </div>
    </Navbar>
  );
}
